import { render } from "./ModalServicesContent.component.vue?vue&type=template&id=32728e97"
import script from "./ModalServicesContent.component.vue?vue&type=script&lang=js"
export * from "./ModalServicesContent.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/phoneBook/servicesContent/servicesContentComponents/ModalServicesContent.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32728e97"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32728e97', __exports__)) {
    console.log('reload')
    api.reload('32728e97', __exports__)
  }
  
  module.hot.accept("./ModalServicesContent.component.vue?vue&type=template&id=32728e97", () => {
    console.log('re-render')
    api.rerender('32728e97', render)
  })

}


export default __exports__